import TitleComponent from '@/components/sc/TitleComponent'
// import SearchComponent from '@/components/sc/SearchComponent'
import SearchComponent from './Search.js'
import PageFooter from '@/components/sc/PageFooter'
import SliderComponent from '@/components/sc/SliderComponent'
import "./list.less"

import React, { useEffect, useState } from 'react'
import { Button, Empty, Image, Pagination, Spin } from 'antd'
import { Link } from "react-router-dom"
import iconProduct from '@/assets/img/icon_product.png'
import NoDataImg from '@/assets/img/home/noData.png'
import api from "@/net/api"
import util from '@/util'

export default function PageProduct(props) {
	const [params, setParams] = useState({
		restaurantId: '',
		storeId: '',
		productId: '',
		currentPage: 1,
	})

	const [table, setTable] = useState({ list: [], total: 0 })
	const PAGE_SIZE = 12
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getList()
	}, [params])

	async function getList() {
		let _params = util.clearParamsEmptyValue({
			...params,
		})
		let param = {
			pageSize: PAGE_SIZE,
			..._params,
			status: "ON",
		}

		setLoading(true)
		try {
			let d = await api.productNourishment_pageList(param)
			setTable({ list: d.list, total: d.total })
		} catch(e) {
			console.log(e)
		} finally {
			setLoading(false)
		}
	}

	function onSearch(data) {
		setParams({ ...params, ...data, currentPage: 1 })
	}

	function onPageChange(page) {
		setParams({ ...params, currentPage: page })
	}
	function pageItemRender(_, type, originalElement) {
		if (type == "prev") {
			return <Button className="page-button">上一页</Button>
		}
		if (type == "next") {
			return <Button className="page-button">下一页</Button>
		}
		return
	}

	return <div className='pages_main_product_list' style={props.style || {}}>
		<TitleComponent title='今日营养餐'></TitleComponent>
		<div className='search_title'>
			<SearchComponent page='product' submitSearch={(data) => { onSearch(data) }}></SearchComponent>
		</div>
		<div className='container_product'>
			<div className="product_main">
			{loading
			? <Spin className="loading" />
			: (table.total == 0
			? <Empty className="empty" imageStyle={{width:'200px',height:'260px'}} image={NoDataImg} description="暂无内容~" />
			: <>
				<div className='product_box'>
				{table.list.map((pro) =>
					<div className='item' key={pro.id}>
						<img
							className='item_img'
							src={pro.absPic}
						/>

						<div className='item_info'>
							<div className='item_name'>{pro.name}</div>
							<div className='item_desc'></div>
							{/* <div className='item_desc'>{pro.restaurantName}-{pro.storeName}</div> */}
							<div className='item_prower'>
								<img
									width={24}
									height={24}
									src={iconProduct}
								/>
								<div>能量值 {pro.energyValue|| 0}KJ/100g</div>
							</div>
							<Link to={"?id=" + pro.id}>
								<Button type="primary" shape="round" className='detail_btn'>查看详情</Button>
							</Link>
						</div>
					</div>
				)}
				</div>
				<Pagination className="pagination" itemRender={pageItemRender} onChange={onPageChange}
					total={table.total} current={params.currentPage} pageSize={PAGE_SIZE} showSizeChanger={false} />
			</>
			)}
			</div>

			<div className='swpier_box'>
				<SliderComponent></SliderComponent>
			</div>
			<PageFooter></PageFooter>
		</div>
	</div>
}
